import { CSRF_TOKEN_ID } from '../constants';

export const getCsrfToken = () => {
  const csrfTokenMeta = document.querySelector(`meta[name='${CSRF_TOKEN_ID}']`);

  return csrfTokenMeta?.getAttribute('content') ?? '';
};

export default getCsrfToken;
